import * as React from 'react';
import '../../css/TestView.scss';
import { Row, Col, Spin } from 'antd';
import CanvasTestView from '../common/canvasTestView';
import strings from '../../eyeguide-localization/test/string.test.view';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
// const thumbsup = require('../../images/thumbup.png');
// const thumbsdown = require('../../images/thumbdown.png');
// const STIMULUS_COLOR: string = '#FFFFFF';
// const BASELINE_COLOR: string = '#0B68F3';
// const TEST_COLOR: string = '#34C849';
// const TEST_COLOR_IMPAIRED: string = '#CE0D24';
// const FOOTER_TEXT_FONT = '14px Arial';

// const TEST_TEXT_FONT = 'bold 14px Arial';
// const SCORE_LABEL_FONT = 'Bold 12px Arial';
// const SCORE_TEXT_FONT = 'bold 20px Arial';

interface ITestViewProp {
    width: any;
    height: any;
    baselinedata: any;
    testdata: any;
    stimulusRequired: boolean;
    isTestImpaired: boolean;
    testText: string;
    testScore: string;
    isOldData: boolean;
    isOldDataBaseline: boolean;
    loading: boolean;
}

interface ITestViewState {
    width: any;
    height: any;
    baselinedata: any;
    testdata: any;
    stimulusRequired: boolean;
    isTestImpaired: boolean;
    testText: string;
    testScore: string;
    isOldData: boolean;
    isOldDataBaseline: boolean;
    loading: boolean;
}

export default class TestView extends React.Component<ITestViewProp, ITestViewState > {
    
    canvas: any;
    constructor(props: ITestViewProp) {
        super(props);
        this.handelStaticKeyChange = this.handelStaticKeyChange.bind(this);
        staticProperties.addEventListener('Main', this.handelStaticKeyChange);
        this.state = {
            width: this.props.width,
            height: this.props.height,
            baselinedata: this.props.baselinedata,
            testdata: this.props.testdata,
            stimulusRequired: this.props.stimulusRequired,
            isTestImpaired: this.props.isTestImpaired,
            testText: this.props.testText === undefined ? '' : this.props.testText,
            testScore: this.props.testScore,
            isOldData: this.props.isOldData,
            isOldDataBaseline: this.props.isOldDataBaseline,
            loading: true
        };
        
    }

    componentDidMount() {
       // const canvas = this.canvas;
        staticProperties.set(STATICKEYS.testViewLoading, true);
        this.setState(
            {
            width: this.props.width,
            height: this.props.height,
            baselinedata: this.props.baselinedata,
            testdata: this.props.testdata,
            stimulusRequired: this.props.stimulusRequired,
            isTestImpaired: this.props.isTestImpaired,
            testText: this.props.testText === undefined ? '' : this.props.testText,
            testScore: this.props.testScore,
            isOldData: this.props.isOldData,
            isOldDataBaseline: this.props.isOldDataBaseline,
        });          
        console.log('componentDidUpdate');

    }

    componentWillReceiveProps(nextProps: any) {
        console.log('componentWillReceiveProps');
        this.setState(
            {
            width: nextProps.width,
            height: nextProps.height,
            baselinedata: nextProps.baselinedata,
            testdata: nextProps.testdata,
            stimulusRequired: nextProps.stimulusRequired,
            isTestImpaired: nextProps.isTestImpaired,
            testText: nextProps.testText === undefined ? '' : nextProps.testText,
            testScore: nextProps.testScore,
            isOldData: nextProps.isOldData,
            isOldDataBaseline: nextProps.isOldDataBaseline,
        },
            () => {
                console.log('');
                this.canvas.width = this.getCanvasWidth();
                this.canvas.height = this.getCanvasHeight();
                this.canvas.style.width = this.canvas.width + 'px';
                this.canvas.style.height = this.canvas.height + 'px';
                this.canvas.getContext('2d').scale(1, 1);
                let canvasView = new CanvasTestView(this.canvas, this.state.baselinedata,
                                                    this.state.testdata, this.state.stimulusRequired,
                                                    this.state.isTestImpaired, this.state.testText, 
                                                    this.state.testScore, this.state.isOldData, 
                                                    this.state.isOldDataBaseline);
                canvasView.setCanvasView();
        });  
    }

    componentDidUpdate() {
        // console.log('componentDidUpdate');
        // let canvasView = new CanvasTestView(this.canvas, this.state.baselinedata,
        //                                     this.state.testdata, this.state.stimulusRequired,
        //                                     this.state.isTestImpaired, this.state.testText, 
        //                                     this.state.testScore, this.state.isOldData, 
        //                                     this.state.isOldDataBaseline);
        // canvasView.setCanvasView();

        // this.drawFrame();

        // if ( this.state.stimulusRequired) {
        //     this.drawStimulus();
        // }
        // if ( this.state.baselinedata !== undefined && this.state.baselinedata.length > 0) {
        //     this.drawBaseLine();
        // }
        // if ( !this.state.stimulusRequired &&  this.state.testdata !== undefined && 
        //                         this.state.testdata.length > 0 ) {
        //     this.drawProfileTest();
        // }
        // this.drawHeaderData();
        // this.drawFooterData();
    }
    
    mean(numbers: Array<any>) {
        let totalx = 0;
        let totaly = 0;

        for (let i = 0; i < numbers.length; i += 1) {
            totalx += numbers[i].x;
            totaly += numbers[i].y;
        }
        return { xmean: totalx / numbers.length, ymean: totaly / numbers.length };
    }

    findboundingbox(numbers: Array<any>) {
        let minx = 999999, maxx = -1, miny = 999999, maxy = -1;
        for (let i = 0; i < numbers.length; i += 1) {
            minx = Math.min( minx, numbers[i].x );
            maxx = Math.max( maxx, numbers[i].x );
            miny = Math.min( miny, numbers[i].y );
            maxy = Math.max( maxy, numbers[i].y );
        }
        return { left: minx, top: miny, right: maxx, bottom: maxy };
    }
  
    render() {
        console.log('center width', window.innerWidth / 2);
        console.log('center Height', window.innerHeight / 2);
        
        return (
           <div className="TestView">
            <Row className="canvasRow">
                <Col xs={1} sm={1} md={2} lg={0} xl={2} />
                <Col className="canvasCol" xs={1} sm={1} md={2} lg={24} xl={20} >
                    <Spin 
                        style={{position: 'absolute', 
                                left: (window.innerWidth / 2) - 
                                      ( screen.width <= 1280 ? 0 : 130 ), 
                                top: (window.innerHeight / 2) - 
                                     ( screen.width <= 1280 ? 100 : 130 ), 
                                zIndex: 1000,
                               }} 
                        spinning={this.state.loading}
                    />
                    <canvas 
                        hidden={this.state.loading} 
                        // hidden={true}                         
                        ref={(canvas) => { this.canvas = canvas; }} 
                        width={this.getCanvasWidth()} 
                        height={this.getCanvasHeight()}
                    /> 
                </Col>
                <Col xs={1} sm={1} md={2} lg={0} xl={2} />
            </Row>
            <Row>
                <Col>
                    <div className="disclaimer"> 
                    {/* <span style={{fontStyle: 'italic'}}>  */}
                     <i className="nowrap-disclaimer">{strings.lsDisclaimerTxt}:</i>
                    {/* </span>  */}
                    {strings.lsDisclaimerInfoTxt}
                        </div>
                </Col>
            </Row>
           </div>
        );
    }

    private getCanvasWidth() {
        return screen.width <= 1280 ? 1024 : 1024;
    }

    private getCanvasHeight() {
        return screen.width <= 1280 ? 768 : 768;
    }   

    private handelStaticKeyChange(key: any, value: any) {
        console.log('handelStaticKeyChange', value, key);
        if ( key === STATICKEYS.testViewLoading && value !== '') {
          console.log('in handlestatic testViewLoading', value);
          this.setState({
              loading: value
          });
        } 
    }

    // private drawFrame() {
    //     const canvas = this.canvas;
    //     const ctx = canvas.getContext('2d');
    //     ctx.fillStyle = 'black';
    //     ctx.strokeStyle = 'black';
    //     ctx.fillRect(0 , 0, this.state.width, this.state.height);
    // }

    // private drawHeaderData() {
    //     const top = 15;
    //     const canvas = this.canvas;
    //     const ctx = canvas.getContext('2d');
    //     // draw footer bar
    //     ctx.fillStyle = '#333333';
    //     ctx.strokeStyle = '#333333';
    //     let headerHeight = (this.state.height * 0.13);
    //     let headerWidth = (this.state.width * 0.25);
    //     this.roundRect( ctx,
    //                     this.canvas.width / 2 - headerWidth / 2 ,
    //                     top,
    //                     headerWidth, headerHeight,
    //                     7, ctx.fillStyle, ctx.strokeStyle );
        
    //     // draw center line
    //     ctx.fillStyle = 'black';
    //     ctx.strokeStyle = 'black';
    //     ctx.fillRect(this.canvas.width / 2 - headerWidth / 2, top + headerHeight / 2, headerWidth, 1);
    //     ctx.fillRect(this.canvas.width / 2 , top + headerHeight / 2, 1, headerHeight - headerHeight / 2);

    //     // draw test result thumbs up
    //     let textWidth = ctx.measureText(this.state.testText).width;
    //     let imgd = new Image();
    //     imgd.src = ! this.state.isTestImpaired ? thumbsup : thumbsdown;
    //     let w = this.canvas.width;
    //     imgd.onload = function() {
    //         ctx.drawImage(imgd, w / 2 - textWidth / 2 - 30 , top + 10, 20, 20);
    //     };
        
    //     // draw score label
    //     ctx.font = SCORE_LABEL_FONT;
    //     ctx.fillStyle = '#FFFFFF';
    //     textWidth = ctx.measureText('Focus Test Score').width;
    //     ctx.fillText(   'Focus Test Score', 
    //                     w / 2 - headerWidth / 2 + (headerWidth / 2 - textWidth) / 2 , 
    //                     top + headerHeight / 4 * 3 + 5 );

    //     // draw test text
    //     ctx.font = TEST_TEXT_FONT;
    //     ctx.fillStyle = this.state.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR;
    //     ctx.fillText( this.state.testText, w / 2 - textWidth / 2 + 10, top + 25 );

    //     // draw score 
    //     ctx.font = SCORE_TEXT_FONT;
    //     textWidth = ctx.measureText(this.state.testScore).width;
    //     ctx.fillText(   this.state.testScore, 
    //                     w / 2 + (headerWidth / 2 - textWidth) / 2 ,  
    //                     top + headerHeight / 4 * 3 + 7 );
    // }

    // private drawFooterData() {
    //     const canvas = this.canvas;
    //     const ctx = canvas.getContext('2d');
    //     // draw footer bar
    //     ctx.fillStyle = '#333333';
    //     let footerHeight = (this.state.height * 0.075);
    //     ctx.fillRect(0, this.state.height - footerHeight, this.state.width, footerHeight );

    //     // Draw Footer
    //     // Text to display
    //     ctx.font = FOOTER_TEXT_FONT;
    //     let txt = this.state.stimulusRequired ? 'STIMULUS          BASELINE' : 'BASELINE          CURRENT TEST'; 
    //     let txtFirst = this.state.stimulusRequired ? 'STIMULUS' : 'BASELINE'; 
    //     let txtSecond = this.state.stimulusRequired ? 'BASELINE' : 'CURRENT TEST'; 
    //     let entireTextWidth = ctx.measureText(txt).width + 55;
    //     let firstTextWidth = ctx.measureText(txtFirst).width + 55;

    //     // draw footer text left
    //     ctx.fillStyle = this.state.stimulusRequired ? STIMULUS_COLOR : BASELINE_COLOR;
    //     let textWidth = entireTextWidth;
    //     let textHeight = ctx.measureText(txtFirst).height === undefined ? 0 : ctx.measureText(txtFirst).height;
    //     let centerx = this.canvas.width / 2 - textWidth / 2;
    //     let centery = this.state.height - footerHeight +  (footerHeight - textHeight) / 2 + 5;
    //     console.log('centerx' , centerx);
    //     console.log('centery', ctx.measureText(txtFirst));
    //     ctx.fillText( txtFirst, centerx + 15 , centery );

    //     // draw circle
    //     let circleRadius = 5;
    //     ctx.beginPath();
    //     ctx.arc( centerx + circleRadius, centery - circleRadius, circleRadius , 0, 2 * Math.PI, false);
    //     ctx.fill();
    //     ctx.strokeStyle = ctx.fillStyle;
    //     ctx.stroke();

    //     // draw footer text right
    //     ctx.fillStyle = this.state.stimulusRequired ? BASELINE_COLOR :
    //                     this.state.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR;
    //     ctx.fillText( txtSecond, centerx + firstTextWidth + 15 , centery );

    //     // draw circle
    //     ctx.beginPath();
    //     ctx.arc( centerx + firstTextWidth + circleRadius, 
    // centery - circleRadius, circleRadius , 0, 2 * Math.PI, false);
    //     ctx.fill();
    //     ctx.strokeStyle = ctx.fillStyle;
    //     ctx.stroke();
    // }

    // private drawStimulus() {
    //     const canvas = this.canvas;
    //     let centerx = this.state.width / 2;
    //     let centery = this.state.height / 2;
    //     const ctx = canvas.getContext('2d');
    //     let frameangle = -Math.PI;
    //     let framecount = 0;
    //     let top = 7 * 60.0 / 2;
    //     let factor = Math.min(  this.state.width / 1.5, this.state.height / 1.5);
    //     ctx.strokeStyle = STIMULUS_COLOR; 
    //     ctx.lineWidth = 8;
    //     ctx.translate(centerx, centery);
    //     ctx.beginPath();
    //     while (true) {
    //         let x = 0;
    //         let y = 0;
    //         if (frameangle < -Math.PI / 2 || frameangle > Math.PI / 2) {
    //                 x = -Math.cos(2 * frameangle) - 1;
    //                 y = Math.sin(2 * frameangle);
    //         } else {
    //                 x = Math.cos(2 * frameangle) + 1;
    //                 y = Math.sin(2 * frameangle);
    //         }
    //         if ( framecount === 0) {
    //             ctx.moveTo(x * factor / 2.0, y * factor / 2.0);
    //         } else {
    //             ctx.lineTo(x * factor / 2.0, y * factor / 2.0);
    //         }

    //         frameangle += Math.PI / top;
    //         if (frameangle > Math.PI) {
    //             frameangle = -Math.PI;
    //         } 
    //         ++framecount;
    //         if (framecount >= 60 * 10) {
    //                 break;
    //         }
    //     }
    //     ctx.stroke();
    //     ctx.closePath();
    //     ctx.resetTransform();
    // }

    // private drawBaseLine() {
    //     this.drawTest( this.state.baselinedata, BASELINE_COLOR);
    // }

    // private drawProfileTest() {
    //     this.drawTest( this.state.testdata, this.state.isTestImpaired ? TEST_COLOR_IMPAIRED : TEST_COLOR);
    // }

    // private drawTest(data: any, color: any) {
    //     const canvas = this.canvas;
    //     const ctx = canvas.getContext('2d');
    //     // let { xmean, ymean } = this.mean(data);
    //     let xmean = 1024 / 2;
    //     let ymean = 768 / 2;
    //     let width: number = canvas.width;
    //     let height: number = canvas.height;
    //     let centerx = width / 2;
    //     let centery = height / 2;
    //     ctx.strokeStyle = color;
    //     ctx.translate(centerx, centery);
    //     // let scalex = centerx / xmean;
    //     // let scaley = centery / ymean;
    //     let scalex = width / 1024;
    //     let scaley = height / 768;
    //     // ctx.scale( scalex * .79, scaley * .78 );
    //     ctx.scale( scalex, scaley );
    //     // xmean = 0;
    //     // ymean = 0;
    //     console.log( window.devicePixelRatio );
    //     // ctx.rotate(20 * Math.PI / 180.0 , 20 * Math.PI / 180);
    //     let bb = this.findboundingbox(data);
                
    //     xmean = (bb.right - bb.left) / 2 - 5;
    //     ymean = (bb.bottom - bb.top) / 2 + 128;
        
    //     ctx.lineWidth = 4;
    //     ctx.beginPath();
    //     ctx.moveTo( (data[0].x - xmean), (data[0].y - ymean ) );
    //     ctx.lineTo( (data[0].x - xmean), (data[0].y - ymean));
    //     ctx.ellipse((data[0].x - xmean), (data[0].y - ymean), 2 , 2 , 0 , 0, 2 * Math.PI); 
    //     ctx.stroke(); 
        
    //     data.forEach( (element: any) => {
    //         ctx.lineTo( (element.x - xmean), (element.y - ymean));
    //         ctx.ellipse((element.x - xmean), (element.y - ymean), 2 , 2 , 0 , 0, 2 * Math.PI); 
    //     });
        
    //     // ctx.closePath();
    //     ctx.stroke();
    //     ctx.resetTransform();  
    // }

    // private roundRect(ctx: any, x: any, y: any, width: any, height: any, radius: any, fill: any, stroke: any) {
        
    //     if (typeof stroke === 'undefined') {
    //       stroke = true;
    //     }
        
    //     if (typeof radius === 'undefined') {
    //       radius = 5;
    //     }
        
    //     if (typeof radius === 'number') {
    //       radius = {tl: radius, tr: radius, br: radius, bl: radius};
    //     } else {
    //       radius = {tl: 0, tr: 0, br: 0, bl: 0};
    //     }

    //     ctx.beginPath();
    //     ctx.moveTo(x + radius.tl, y);
    //     ctx.lineTo(x + width - radius.tr, y);
    //     ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    //     ctx.lineTo(x + width, y + height - radius.br);
    //     ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    //     ctx.lineTo(x + radius.bl, y + height);
    //     ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    //     ctx.lineTo(x, y + radius.tl);
    //     ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    //     ctx.closePath();
    //     if (fill) {
    //       ctx.fill();
    //     }
    //     if (stroke) {
    //       ctx.stroke();
    //     }      
    //   }
    // private getBaseLineData() {
    //     return [
    //         { x: 152.4501642935378,	y: 175.5564074479737 },
    //         { x: 153.09,	y: 175.64 },
    //         { x: 153.73777777777778,	y: 175.71333333333334 },
    //         { x: 153.5069967707212,	y: 175.28525296017222 },
    //         { x: 153.511758118701,	y: 175.44456886898098 },
    //         { x: 153.60801781737194,	y: 175.6759465478842 },
    //         { x: 153.52508361204013,	y: 175.53846153846155 },
    //         { x: 153.6685456595265,	y: 175.62006764374297 },
    //         { x: 153.7262443438914,	y: 175.50678733031674 },
    //         { x: 153.88122171945702,	y: 175.6131221719457 },
    //         { x: 153.6719817767654,	y: 175.625284738041 },
    //         { x: 153.67087155963304,	y: 175.4954128440367 },
    //         { x: 153.6818181818182,	y: 175.70454545454544 },
    //         { x: 153.78153153153153,	y: 175.5011261261261 },
    //         { x: 153.86498855835242,	y: 175.52402745995423 },
    //         { x: 153.55302166476625,	y: 175.7970353477765 },
    //         { x: 152.6836027713626,	y: 176.42147806004618 },
    //         { x: 153.01814058956916,	y: 176.26643990929705 },
    //         { x: 152.81930415263747,	y: 176.70819304152639 },
    //         { x: 152.8717067583047,	y: 176.71363115693012 },
    //         { x: 152.9866220735786,	y: 176.56744704570792 },
    //         { x: 152.9387755102041,	y: 176.74489795918367 },
    //         { x: 153.13600891861762,	y: 177.02229654403567 },
    //         { x: 153.42888643880926,	y: 176.90518191841235 },
    //         { x: 153.40655737704918,	y: 177.09945355191257 },
    //         { x: 153.36824696802645,	y: 178.45093715545755 },
    //         { x: 153.47225244831338,	y: 178.51251360174103 },
    //         { x: 153.61587982832617,	y: 178.62231759656652 },
    //         { x: 153.7838405036726,	y: 178.76390346274923 },
    //         { x: 153.7218124341412,	y: 178.97787144362488 },
    //         { x: 153.98121085594988,	y: 178.80688935281836 },
    //         { x: 154.04722792607802,	y: 179.0482546201232 },
    //         { x: 154.18210197710718,	y: 179.38605619146722 },
    //         { x: 154.56868686868688,	y: 179.220202020202 },
    //         { x: 154.8909465020576,	y: 179.5514403292181 },
    //         { x: 155.16414904330313,	y: 179.40684793554885 },
    //         { x: 155.6433637284701,	y: 179.68085106382978 },
    //         { x: 155.9235412474849,	y: 179.71931589537223 },
    //         { x: 155.94720812182743,	y: 180.03045685279187 },
    //         { x: 156.3621031746032,	y: 180.00198412698413 },
    //         { x: 156.62151394422312,	y: 179.9581673306773 },
    //         { x: 156.9269496544916,	y: 180.19052319842052 },
    //         { x: 157.58904109589042,	y: 180.1399217221135 },
    //         { x: 157.59477756286267,	y: 180.3752417794971 },
    //         { x: 157.92801556420233,	y: 180.22178988326849 },
    //         { x: 157.99326275264679,	y: 180.42829643888354 },
    //         { x: 158.58712121212122,	y: 180.43560606060606 },
    //         { x: 158.7264061010486,	y: 180.6148713060057 },
    //         { x: 159.0009505703422,	y: 180.74144486692015 },
    //         { x: 159.49381541389153,	y: 180.69267364414844 },
    //         { x: 159.77105014191108,	y: 180.72374645222328 },
    //         { x: 160.06742640075973,	y: 180.5394112060779 },
    //         { x: 160.2882968601332,	y: 180.8058991436727 },
    //         { x: 160.35721200387223,	y: 180.8673765730881 },
    //         { x: 161.16274694261523,	y: 181.75634995296332 },
    //         { x: 161.54186265286924,	y: 181.77046095954844 },
    //         { x: 162.0245283018868,	y: 181.42830188679244 },
    //         { x: 162.34014869888478,	y: 181.55018587360595 },
    //         { x: 162.67920978363122,	y: 181.63123236124176 },
    //         { x: 162.9556786703601,	y: 181.2169898430286 },
    //         { x: 163.3769730733519,	y: 181.62952646239555 },
    //         { x: 163.53916211293262,	y: 181.61657559198542 },
    //         { x: 163.6657381615599,	y: 181.5218198700093 },
    //         { x: 163.99074930619798,	y: 181.51156336725253 },
    //         { x: 164.3173873045078,	y: 181.44526218951242 },
    //         { x: 164.3579335793358,	y: 181.41512915129152 },
    //         { x: 164.87859712230215,	y: 181.40827338129498 },
    //         { x: 165.1461187214612,	y: 181.36712328767123 },
    //         { x: 165.53059360730595,	y: 181.25570776255708 },
    //         { x: 165.58502772643254,	y: 181.40295748613678 },
    //         { x: 165.9041474654378,	y: 181.3078341013825 },
    //         { x: 165.81158088235293,	y: 181.18474264705884 },
    //         { x: 166.1942379182156,	y: 180.97118959107806 },
    //         { x: 166.69795539033458,	y: 181.0817843866171 },
    //         { x: 167.0785046728972,	y: 181.00841121495327 },
    //         { x: 167.10261194029852,	y: 181.06529850746267 },
    //         { x: 167.5618604651163,	y: 181.04093023255814 },
    //         { x: 168.1554307116105,	y: 180.83052434456928 },
    //         { x: 168.45738636363637,	y: 180.88352272727272 },
    //         { x: 168.73778195488723,	y: 180.53665413533835 },
    //         { x: 169.15545023696683,	y: 180.64454976303318 },
    //         { x: 169.4255924170616,	y: 180.63222748815167 },
    //         { x: 169.8435114503817,	y: 180.1908396946565 },
    //         { x: 170.05123339658445,	y: 180.19449715370018 },
    //         { x: 170.12596153846152,	y: 180.32788461538462 },
    //         { x: 170.4035087719298,	y: 180.21247563352827 },
    //         { x: 170.50844091360477,	y: 180.10327706057598 },
    //         { x: 170.65312190287415,	y: 179.97026759167494 },
    //         { x: 170.71245059288538,	y: 179.8586956521739 },
    //         { x: 170.858407079646,	y: 179.9006882989184 },
    //         { x: 171.23913043478262,	y: 179.79446640316206 },
    //         { x: 171.35828343313375,	y: 179.96407185628743 },
    //         { x: 171.65113974231912,	y: 179.58572844400396 },
    //         { x: 171.78443113772454,	y: 179.82135728542914 },
    //         { x: 172.03726082578046,	y: 179.8036253776435 },
    //         { x: 172.28716904276985,	y: 179.5936863543788 },
    //         { x: 172.41306532663316,	y: 179.45125628140704 },
    //         { x: 172.53746253746255,	y: 179.5064935064935 },
    //         { x: 172.98992950654582,	y: 179.3413897280967 },
    //         { x: 173.22538071065992,	y: 179.20609137055837 },
    //         { x: 173.29618473895584,	y: 179.05421686746988 },
    //         { x: 173.6723107569721,	y: 178.84362549800795 },
    //         { x: 173.91963377416073,	y: 178.5239064089522 },
    //         { x: 174.18024439918534,	y: 178.5030549898167 },
    //         { x: 174.00817160367723,	y: 178.51685393258427 },
    //         { x: 174.44994840041278,	y: 178.32094943240455 },
    //         { x: 174.75458248472506,	y: 178.11710794297352 },
    //         { x: 174.80971659919027,	y: 178.04655870445345 },
    //         { x: 174.81549439347606,	y: 177.98165137614677 },
    //         { x: 174.87755102040816,	y: 177.95408163265307 },
    //         { x: 174.98455200823895,	y: 177.86508753861997 },
    //         { x: 175.06365503080082,	y: 177.67556468172484 },
    //         { x: 175.1867088607595,	y: 177.46835443037975 },
    //         { x: 175.33611691022963,	y: 177.30584551148226 },
    //         { x: 175.38272921108742,	y: 177.22494669509595 },
    //         { x: 175.26411075612353,	y: 177.23961661341855 },
    //         { x: 175.43562231759657,	y: 176.94957081545064 },
    //         { x: 174.84375,	y: 176.73922413793105 },
    //         { x: 175.1127659574468,	y: 176.37021276595743 },
    //         { x: 175.24264705882354,	y: 176.37394957983193 },
    //         { x: 175.44055201698512,	y: 176.3067940552017 },
    //         { x: 175.4140127388535,	y: 176.0456475583864 },
    //         { x: 175.62473347547973,	y: 175.93710021321962 },
    //         { x: 175.9051724137931,	y: 175.8793103448276 },
    //         { x: 176.1528384279476,	y: 175.81004366812226 },
    //         { x: 176.29217199558985,	y: 175.5777287761852 },
    //         { x: 176.6800894854586,	y: 175.3993288590604 },
    //         { x: 176.8721058434399,	y: 175.37265711135612 },
    //         { x: 176.94084821428572,	y: 175.25 },
    //         { x: 177.1208053691275,	y: 175.10402684563758 },
    //         { x: 177.45343680709533,	y: 175.02328159645234 },
    //         { x: 177.91451068616425,	y: 175.03937007874015 },
    //         { x: 178.41610738255034,	y: 174.98322147651007 },
    //         { x: 178.30347144456886,	y: 174.91265397536395 },
    //         { x: 178.69187986651835,	y: 174.83982202447163 },
    //         { x: 179.1365688487585,	y: 174.79345372460497 },
    //         { x: 179.54740406320542,	y: 174.58803611738148 },
    //         { x: 179.8072976054732,	y: 174.62029646522234 },
    //         { x: 179.97404063205417,	y: 174.56546275395033 },
    //         { x: 180.15384615384616,	y: 174.57971014492753 },
    //         { x: 180.42953776775647,	y: 174.25817361894025 },
    //         { x: 180.7384792626728,	y: 173.63824884792626 },
    //         { x: 180.931151241535,	y: 173.47968397291197 },
    //         { x: 181.296,	y: 173.45714285714286 },
    //         { x: 181.7986030267753,	y: 173.46449359720606 },
    //         { x: 182.0997732426304,	y: 173.35487528344672 },
    //         { x: 182.1655172413793,	y: 173.3793103448276 },
    //         { x: 182.6869266055046,	y: 173.16743119266056 },
    //         { x: 182.893470790378,	y: 173.24742268041237 },
    //         { x: 183.27241770715096,	y: 173.25312145289445 },
    //         { x: 183.57061503416855,	y: 173.1492027334852 },
    //         { x: 184.18161180476733,	y: 173.0817253121453 },
    //         { x: 184.65750286368842,	y: 173.04581901489118 },
    //         { x: 185.0561282932417,	y: 172.98969072164948 },
    //         { x: 185.22722029988466,	y: 173.0565167243368 },
    //         { x: 185.52286049237983,	y: 173.0879249706917 },
    //         { x: 185.96917808219177,	y: 172.8824200913242 },
    //         { x: 186.43314285714285,	y: 172.8057142857143 },
    //         { x: 186.99419279907085,	y: 172.92566782810684 },
    //         { x: 187.10206422018348,	y: 173.01605504587155 },
    //         { x: 187.52528735632183,	y: 172.96896551724137 },
    //         { x: 187.82175925925924,	y: 172.83796296296296 },
    //         { x: 188.33026467203683,	y: 172.79976985040275 },
    //         { x: 188.96651270207852,	y: 172.6916859122402 },
    //         { x: 189.4126611957796,	y: 172.85580304806564 },
    //         { x: 189.7349537037037,	y: 172.84953703703704 },
    //         { x: 190.44302325581396,	y: 172.66976744186047 },
    //         { x: 190.7806301050175,	y: 172.63010501750293 },
    //         { x: 191.08028335301063,	y: 172.86658795749705 },
    //         { x: 191.24882075471697,	y: 173.01061320754718 },
    //         { x: 191.59526627218935,	y: 172.89940828402368 },
    //         { x: 192.0523186682521,	y: 172.88941736028536 },
    //         { x: 192.2224852071006,	y: 172.9431952662722 },
    //         { x: 192.5685096153846,	y: 173.2091346153846 },
    //         { x: 192.95186522262333,	y: 173.26714801444044 },
    //         { x: 193.014440433213,	y: 173.34416365824308 },
    //         { x: 193.46514423076923,	y: 173.20673076923077 },
    //         { x: 194.0206561360875,	y: 173.38639125151883 },
    //         { x: 193.95604395604397,	y: 173.54456654456655 },
    //         { x: 194.4789603960396,	y: 173.6039603960396 },
    //         { x: 194.6813186813187,	y: 173.56654456654456 },
    //         { x: 194.91985203452526,	y: 173.6078914919852 },
    //         { x: 195.320987654321,	y: 173.64691358024692 },
    //         { x: 195.48488664987406,	y: 173.8501259445844 },
    //         { x: 195.69849246231155,	y: 173.80904522613065 },
    //         { x: 196.1166253101737,	y: 173.8002481389578 },
    //         { x: 196.43990086741016,	y: 173.92688971499382 },
    //         { x: 196.4077306733167,	y: 173.8865336658354 },
    //         { x: 196.72885572139302,	y: 173.8917910447761 },
    //         { x: 196.8709677419355,	y: 174.00372208436724 },
    //         { x: 196.9664596273292,	y: 173.99627329192546 },
    //         { x: 197.11083437110835,	y: 174.11083437110835 },
    //         { x: 198.34587378640776,	y: 174.75 },
    //         { x: 198.15643802647412,	y: 174.99879663056558 },
    //         { x: 198.36374695863748,	y: 175.19586374695865 },
    //         { x: 198.30085261875763,	y: 175.1729598051157 },
    //         { x: 198.40576230492195,	y: 175.23649459783914 },
    //         { x: 198.83333333333331,	y: 175.49756690997566 },
    //         { x: 198.9273607748184,	y: 175.62348668280873 },
    //         { x: 198.72956730769232,	y: 175.68269230769232 },
    //         { x: 198.7265160523187,	y: 175.68133174791916 },
    //         { x: 198.98687350835323,	y: 175.75059665871123 },
    //         { x: 198.99162679425837,	y: 175.69856459330143 },
    //         { x: 198.94610778443115,	y: 175.83233532934133 },
    //         { x: 199.28571428571428,	y: 175.98110979929163 },
    //         { x: 198.94976076555025,	y: 176.03827751196172 },
    //         { x: 199.02016607354687,	y: 175.8540925266904 },
    //         { x: 199.16018845700825,	y: 175.94935217903415 },
    //         { x: 199.11280846063454,	y: 176.25381903642773 },
    //         { x: 199.49485714285714,	y: 177.36114285714285 },
    //         { x: 199.45842956120094,	y: 177.47113163972287 },
    //         { x: 199.3900462962963,	y: 177.50925925925927 },
    //         { x: 199.35630841121497,	y: 177.72196261682242 },
    //         { x: 199.37149532710282,	y: 177.76869158878503 },
    //         { x: 199.4952718676123,	y: 177.79669030732862 },
    //         { x: 199.50947867298578,	y: 177.96327014218008 },
    //         { x: 199.3016241299304,	y: 178.0707656612529 },
    //         { x: 199.5792540792541,	y: 178.13170163170162 },
    //         { x: 199.50578703703704,	y: 178.2476851851852 },
    //         { x: 199.3933102652826,	y: 178.1926182237601 },
    //         { x: 198.99424626006905,	y: 178.4510932105869 },
    //         { x: 199.1355140186916,	y: 178.47663551401868 },
    //         { x: 199.18577981651376,	y: 178.598623853211 },
    //         { x: 198.9080459770115,	y: 178.5712643678161 },
    //         { x: 198.80593607305934,	y: 178.74429223744292 },
    //         { x: 198.04794520547944,	y: 178.97260273972603 },
    //         { x: 196.2032520325203,	y: 179.95702671312426 },
    //         { x: 196.45589919816723,	y: 180.12600229095074 },
    //         { x: 196.2362385321101,	y: 180.05733944954127 },
    //         { x: 196.31050228310502,	y: 180.12100456621005 },
    //         { x: 196.14840182648402,	y: 180.28310502283105 },
    //         { x: 195.91845979614948,	y: 180.63986409966026 },
    //         { x: 195.60496613995485,	y: 180.66027088036117 },
    //         { x: 195.42342342342343,	y: 180.7072072072072 },
    //         { x: 195.3011235955056,	y: 180.7629213483146 },
    //         { x: 194.62639821029083,	y: 180.75615212527964 },
    //         { x: 194.39090909090908,	y: 180.8409090909091 },
    //         { x: 194.29830508474578,	y: 180.94350282485874 },
    //         { x: 194,	y: 180.97536394176933 },
    //         { x: 193.917225950783,	y: 180.92505592841164 },
    //         { x: 193.56387665198238,	y: 181.11233480176213 },
    //         { x: 193.35044642857144,	y: 181.16294642857144 },
    //         { x: 193.29295154185021,	y: 181.05286343612335 },
    //         { x: 193.12021857923497,	y: 181.17704918032786 },
    //         { x: 193.0938864628821,	y: 181.9956331877729 },
    //         { x: 192.61706783369803,	y: 182.0929978118162 },
    //         { x: 192.1098901098901,	y: 181.94615384615383 },
    //         { x: 192.0207650273224,	y: 182.14972677595628 },
    //         { x: 191.67783783783784,	y: 182.17945945945945 },
    //         { x: 191.44805194805195,	y: 182.2900432900433 },
    //         { x: 190.98032786885244,	y: 182.18688524590164 },
    //         { x: 190.75109170305677,	y: 182.33515283842794 },
    //         { x: 190.20064377682405,	y: 182.33798283261802 },
    //         { x: 189.91173304628632,	y: 182.39289558665232 },
    //         { x: 189.66666666666669,	y: 182.48534201954396 },
    //         { x: 189.21483097055616,	y: 182.67175572519085 },
    //         { x: 188.65113759479956,	y: 182.61430119176597 },
    //         { x: 188.50601092896176,	y: 182.53005464480873 },
    //         { x: 188.04550379198267,	y: 182.50812567713976 },
    //         { x: 187.94316939890712,	y: 182.73005464480875 },
    //         { x: 187.40869565217392,	y: 182.65217391304347 },
    //         { x: 187.0959651035987,	y: 182.56052344601963 },
    //         { x: 186.5753575357536,	y: 182.67546754675467 },
    //         { x: 186.0958605664488,	y: 183.06644880174292 },
    //         { x: 185.76232201533406,	y: 183.07776560788608 },
    //         { x: 185.39955849889623,	y: 183.07395143487858 },
    //         { x: 185.1947194719472,	y: 183.1001100110011 },
    //         { x: 184.84454244762955,	y: 182.95700110253583 },
    //         { x: 184.1583514099783,	y: 183.0704989154013 },
    //         { x: 183.79824561403507,	y: 183.12719298245614 },
    //         { x: 183.8527808069793,	y: 183.11886586695746 },
    //         { x: 183.63135135135136,	y: 183.0918918918919 },
    //         { x: 183.2399565689468,	y: 182.96199782844735 },
    //         { x: 182.8445652173913,	y: 183.01195652173914 },
    //         { x: 182.23841059602648,	y: 182.92825607064017 },
    //         { x: 181.92383025027203,	y: 183.0272034820457 },
    //         { x: 181.52735229759298,	y: 182.9945295404814 },
    //         { x: 181.1349892008639,	y: 182.76565874730022 },
    //         { x: 181.0743169398907,	y: 182.80109289617485 },
    //         { x: 180.89154013015184,	y: 182.7581344902386 },
    //         { x: 180.4551422319475,	y: 182.59628008752736 },
    //         { x: 180.21790722761597,	y: 182.47033441208197 },
    //         { x: 180.00108813928182,	y: 182.4461371055495 },
    //         { x: 179.31372549019608,	y: 182.52723311546842 },
    //         { x: 179.31038251366118,	y: 182.39016393442623 },
    //         { x: 179.05228758169935,	y: 182.18409586056646 },
    //         { x: 178.7792207792208,	y: 182.23160173160173 },
    //         { x: 178.60592755214049,	y: 182.17233809001098 },
    //         { x: 178.42716319824754,	y: 182.06243154435924 },
    //         { x: 178.24441964285714,	y: 182.01674107142856 },
    //         { x: 177.60470324748042,	y: 181.8073908174692 },
    //         { x: 177.30444697833525,	y: 181.64880273660205 },
    //         { x: 177.13641488162347,	y: 181.46448703494926 },
    //         { x: 176.8132118451025,	y: 181.3633257403189 },
    //         { x: 176.84615384615384,	y: 181.23755656108597 },
    //         { x: 176.77136258660508,	y: 181.34526558891454 },
    //         { x: 176.36258660508082,	y: 181.13972286374133 },
    //         { x: 176.23210161662817,	y: 181.2066974595843 },
    //         { x: 175.96487119437938,	y: 181.0081967213115 },
    //         { x: 175.89779326364692,	y: 180.86411149825784 },
    //         { x: 175.83294117647057,	y: 180.84117647058824 },
    //         { x: 175.69615832363212,	y: 180.70197904540163 },
    //         { x: 175.45221445221443,	y: 180.62820512820514 },
    //         { x: 173.5334928229665,	y: 180.08133971291866 },
    //         { x: 173.47914183551848,	y: 179.41835518474375 },
    //         { x: 173.56872037914692,	y: 179.3957345971564 },
    //         { x: 173.2829964328181,	y: 179.25683709869202 },
    //         { x: 173.2239520958084,	y: 179.03473053892216 },
    //         { x: 173.0047449584816,	y: 178.98813760379596 },
    //         { x: 173.271327014218,	y: 178.9490521327014 },
    //         { x: 173.15845070422534,	y: 178.86150234741785 },
    //         { x: 173.25802615933412,	y: 178.7681331747919 },
    //         { x: 173.23305588585018,	y: 178.59809750297265 },
    //         { x: 173.05748502994012,	y: 178.45269461077845 },
    //         { x: 173.02372479240807,	y: 178.2870699881376 },
    //         { x: 173.16206482593037,	y: 178.1968787515006 },
    //         { x: 173.1768292682927,	y: 178.11707317073171 },
    //         { x: 172.99271844660194,	y: 177.7888349514563 },
    //         { x: 173.1640146878825,	y: 177.69767441860466 },
    //         { x: 173.048602673147,	y: 177.5722964763062 },
    //         { x: 173.048602673147,	y: 177.40704738760633 },
    //         { x: 173.3001200480192,	y: 177.3001200480192 },
    //         { x: 173.02173913043478,	y: 177.1413043478261 },
    //         { x: 173.2355769230769,	y: 177.03846153846155 },
    //         { x: 173.256038647343,	y: 176.96014492753625 },
    //         { x: 173.12576312576311,	y: 176.81562881562883 },
    //         { x: 173.32527206771465,	y: 176.56227327690448 },
    //         { x: 173.27884615384616,	y: 176.55889423076923 },
    //         { x: 173.5128834355828,	y: 176.46503067484662 },
    //         { x: 173.53225806451613,	y: 176.48387096774195 },
    //         { x: 173.27730061349695,	y: 176.2920245398773 },
    //         { x: 173.28553770086526,	y: 176.15080346106305 },
    //         { x: 173.44143033292232,	y: 175.6276202219482 },
    //         { x: 173.3152709359606,	y: 175.435960591133 },
    //         { x: 173.30710659898477,	y: 175.48350253807106 },
    //         { x: 173.23595505617976,	y: 175.37203495630462 },
    //         { x: 173.17125,	y: 175.09625 },
    //         { x: 172.83457711442787,	y: 175.12562189054728 },
    //         { x: 172.2255266418835,	y: 175.0086741016109 },
    //         { x: 172.61779448621553,	y: 174.78070175438597 },
    //         { x: 172.0251572327044,	y: 174.80377358490566 },
    //         { x: 172.13076923076923,	y: 174.56923076923078 },
    //         { x: 171.92041078305522,	y: 174.45827984595635 },
    //         { x: 171.82776349614397,	y: 174.25192802056554 },
    //         { x: 171.56476683937825,	y: 174.16968911917098 },
    //         { x: 171.47600518806746,	y: 174.04669260700388 },
    //         { x: 171.15858453473132,	y: 174.0340760157274 },
    //         { x: 170.98818897637796,	y: 173.91994750656167 },
    //         { x: 170.6942257217848,	y: 173.83595800524935 },
    //         { x: 170.51870967741934,	y: 173.79096774193548 },
    //         { x: 170.42539267015707,	y: 173.7041884816754 },
    //         { x: 169.90364583333331,	y: 173.66145833333334 },
    //         { x: 169.61185983827494,	y: 173.5700808625337 },
    //         { x: 169.33815789473684,	y: 173.4736842105263 },
    //         { x: 168.69322709163345,	y: 173.3824701195219 },
    //         { x: 168.6904761904762,	y: 173.20767195767195 },
    //         { x: 168.1682119205298,	y: 173.02649006622516 },
    //         { x: 167.9,	y: 173.03684210526316 },
    //         { x: 167.64900662251654,	y: 172.8503311258278 },
    //         { x: 167.37283621837548,	y: 172.64181091877498 },
    //         { x: 167.06933333333333,	y: 172.644 },
    //         { x: 166.66755319148936,	y: 172.55585106382978 },
    //         { x: 166.43650793650795,	y: 172.4695767195767 },
    //         { x: 166.25459317585302,	y: 172.3713910761155 },
    //         { x: 165.85078534031413,	y: 172.27225130890054 },
    //         { x: 165.43908969210173,	y: 172.21954484605087 },
    //         { x: 165.38926174496646,	y: 172.23221476510068 },
    //         { x: 165.125,	y: 172.24048913043478 },
    //         { x: 164.83604336043362,	y: 172.2330623306233 },
    //         { x: 163.21187584345478,	y: 172.23481781376518 },
    //         { x: 162.7741935483871,	y: 172.1451612903226 },
    //         { x: 162.34146341463415,	y: 172.21273712737127 },
    //         { x: 162.12988826815644,	y: 172.19692737430168 },
    //         { x: 162.10641200545703,	y: 172.25920873124147 },
    //         { x: 161.34344827586207,	y: 172.24965517241378 },
    //         { x: 161.09756097560975,	y: 172.28997289972898 },
    //         { x: 160.84636488340192,	y: 172.22633744855966 },
    //         { x: 160.40360610263522,	y: 172.2246879334258 },
    //         { x: 160.23233695652175,	y: 172.28940217391306 },
    //         { x: 159.87193460490465,	y: 172.17574931880108 },
    //         { x: 159.5430107526882,	y: 172.33602150537635 },
    //         { x: 159.25733333333335,	y: 172.244 },
    //         { x: 159.14538043478262,	y: 172.3736413043478 },
    //         { x: 158.61569688768606,	y: 172.38565629228688 },
    //         { x: 158.39811066126856,	y: 172.44534412955466 },
    //         { x: 158.39147802929426,	y: 172.54327563249 },
    //         { x: 158.01212938005392,	y: 172.60377358490567 },
    //         { x: 157.44664031620553,	y: 172.51910408432147 },
    //         { x: 157.13671875,	y: 172.88802083333334 },
    //         { x: 156.87186261558784,	y: 172.73051519154558 },
    //         { x: 156.71315789473684,	y: 172.8657894736842 },
    //         { x: 156.67666232073012,	y: 173.01173402868318 },
    //         { x: 156.24476439790575,	y: 172.94502617801047 },
    //         { x: 155.94155844155844,	y: 173.06623376623378 },
    //         { x: 155.95865633074936,	y: 173.01679586563307 },
    //         { x: 155.76455368693402,	y: 173.15006468305305 },
    //         { x: 155.2,	y: 173.31612903225806 },
    //         { x: 154.9987029831388,	y: 173.2892347600519 },
    //         { x: 154.85166240409205,	y: 173.43606138107418 },
    //         { x: 154.76202860858257,	y: 173.556566970091 },
    //         { x: 154.95719844357978,	y: 173.50453955901426 },
    //         { x: 154.01708278580816,	y: 173.94743758212877 },
    //         { x: 153.27471116816432,	y: 174.8048780487805 },
    //         { x: 153.03608247422682,	y: 174.77835051546393 },
    //         { x: 152.81806451612903,	y: 174.8141935483871 },
    //         { x: 152.96934865900383,	y: 174.9463601532567 },
    //         { x: 152.77820512820512,	y: 174.95128205128205 },
    //         { x: 152.319391634981,	y: 174.99493029150824 },
    //         { x: 152.07496823379924,	y: 175.04701397712833 },
    //         { x: 151.95524296675194,	y: 175.2544757033248 },
    //         { x: 152.16815286624205,	y: 175.17070063694268 },
    //         { x: 151.80744544287546,	y: 175.30166880616173 },
    //         { x: 151.72727272727275,	y: 175.52240717029449 },
    //         { x: 151.8405612244898,	y: 175.46938775510205 },
    //         { x: 151.77070063694268,	y: 175.47770700636943 },
    //         { x: 151.7541613316261,	y: 175.79257362355955 },
    //         { x: 151.698595146871,	y: 175.65900383141764 },
    //         { x: 151.68612191958493,	y: 175.7302204928664 },
    //         { x: 151.7058064516129,	y: 175.7367741935484 },
    //         { x: 151.60026041666669,	y: 176.12239583333334 },
    //         { x: 151.4187256176853,	y: 176.26397919375813 },
    //         { x: 151.33204633204633,	y: 176.24066924066923 },
    //         { x: 150.50514138817482,	y: 177.05269922879177 },
    //         { x: 150.75476493011436,	y: 177.57941550190597 },
    //         { x: 150.89769820971867,	y: 177.78132992327366 },
    //         { x: 150.99092088197148,	y: 177.62645914396887 },
    //         { x: 151.02281368821292,	y: 177.8339670468948 },
    //         { x: 151.06775407779173,	y: 177.89084065244668 },
    //         { x: 151.14612452350698,	y: 178.04701397712833 },
    //         { x: 151.04369538077404,	y: 178.08988764044943 },
    //         { x: 151.2406015037594,	y: 178.1766917293233 },
    //         { x: 151.14861460957178,	y: 178.24811083123427 },
    //         { x: 151.21238938053096,	y: 178.36156763590392 },
    //         { x: 151.47667087011348,	y: 178.2156368221942 },
    //         { x: 151.11278195488723,	y: 178.57393483709274 },
    //         { x: 151.48379052369077,	y: 178.55236907730674 },
    //         { x: 151.2942643391521,	y: 178.60224438902742 },
    //         { x: 151.37220843672458,	y: 178.8151364764268 },
    //         { x: 150.747572815534,	y: 179.69417475728156 },
    //         { x: 151.11138014527845,	y: 179.65496368038743 },
    //         { x: 151.4111922141119,	y: 179.73114355231144 },
    //         { x: 151.32777115613825,	y: 179.84266984505365 },
    //         { x: 151.5729794933655,	y: 179.8431845597105 },
    //         { x: 151.79761904761904,	y: 179.93690476190477 },
    //         { x: 152.12529550827423,	y: 180.06501182033097 },
    //         { x: 152.31914893617022,	y: 180.05200945626478 },
    //         { x: 152.49112426035504,	y: 180.1337278106509 },
    //         { x: 152.46318289786223,	y: 180.2600950118765 },
    //         { x: 152.85614035087718,	y: 180.24444444444444 },
    //         { x: 152.84534883720931,	y: 180.1906976744186 },
    //         { x: 153.11858608893957,	y: 180.27251995438996 },
    //         { x: 153.39362912400455,	y: 180.19567690557452 },
    //         { x: 153.82299887260427,	y: 180.28974069898533 },
    //         { x: 154.05842696629213,	y: 180.30224719101125 },
    //         { x: 153.33446327683617,	y: 180.74463276836158 },
    //         { x: 153.76879910213245,	y: 181.2368125701459 },
    //         { x: 153.95560488346283,	y: 181.02663706992232 },
    //         { x: 154.03812636165577,	y: 181.11546840958607 },
    //         { x: 153.92729306487695,	y: 181.56375838926175 },
    //         { x: 153.97797356828193,	y: 181.52643171806167 },
    //         { x: 154.29464285714286,	y: 181.55803571428572 },
    //         { x: 154.30676855895194,	y: 181.40720524017468 },
    //         { x: 154.5885588558856,	y: 181.5775577557756 },
    //         { x: 155.1134903640257,	y: 181.71627408993575 },
    //         { x: 155.38569880823403,	y: 181.73456121343446 },
    //         { x: 155.75,	y: 181.6939655172414 },
    //         { x: 156.04501607717043,	y: 181.64523043944266 },
    //         { x: 156.38740661686234,	y: 181.62113127001066 },
    //         { x: 156.6936353829558,	y: 181.86299892125135 },
    //         { x: 156.9153605015674,	y: 181.72831765935214 },
    //         { x: 157.83298755186723,	y: 181.86410788381744 },
    //         { x: 158.01888772298008,	y: 182.09024134312696 },
    //         { x: 158.23516949152543,	y: 182.09957627118644 },
    //         { x: 158.84375,	y: 181.85625 },
    //         { x: 159.05765199161425,	y: 181.96331236897274 },
    //         { x: 159.3728813559322,	y: 182.0677966101695 },
    //         { x: 159.635593220339,	y: 181.9237288135593 },
    //         { x: 159.8553191489362,	y: 181.94255319148937 },
    //         { x: 159.91192266380236,	y: 182.2749731471536 },
    //         { x: 160.62459893048128,	y: 182.11550802139038 },
    //         { x: 160.91894736842107,	y: 182.09578947368422 },
    //         { x: 161.18996798292423,	y: 182.05336179295625 },
    //         { x: 161.41505376344088,	y: 181.9967741935484 },
    //         { x: 161.69441517386724,	y: 181.9504741833509 },
    //         { x: 161.97770700636943,	y: 182.06050955414014 },
    //         { x: 162.2411953041622,	y: 182.05016008537888 },
    //         { x: 162.62420382165607,	y: 181.947983014862 },
    //         { x: 162.9873015873016,	y: 181.86878306878307 },
    //         { x: 163.31163287086446,	y: 181.87620064034152 },
    //         { x: 163.3978260869565,	y: 181.75434782608696 },
    //         { x: 163.83582089552237,	y: 181.75159914712154 },
    //         { x: 164.22707423580786,	y: 181.7707423580786 },
    //         { x: 164.5844017094017,	y: 181.55235042735043 },
    //         { x: 164.8063112078346,	y: 181.50163220892273 },
    //         { x: 165.03485838779955,	y: 181.66230936819173 },
    //         { x: 165.37703141928495,	y: 181.465872156013 },
    //         { x: 165.66922234392115,	y: 181.38882803943045 },
    //         { x: 165.95973154362417,	y: 181.3903803131991 },
    //         { x: 166.41816143497758,	y: 181.13452914798205 },
    //         { x: 166.67045454545456,	y: 181.24318181818182 },
    //         { x: 167.0615034168565,	y: 181.17881548974944 },
    //         { x: 167.4246885617214,	y: 181.11551528878823 },
    //         { x: 167.75336322869956,	y: 180.9708520179372 },
    //         { x: 167.8998862343572,	y: 180.83048919226394 },
    //         { x: 168.3457627118644,	y: 180.67344632768362 },
    //         { x: 168.4949152542373,	y: 180.64180790960452 },
    //         { x: 168.8196166854566,	y: 180.3652762119504 },
    //         { x: 168.91770011273957,	y: 180.35625704622322 },
    //         { x: 169.04936854190584,	y: 180.38920780711825 },
    //         { x: 169.34201585503962,	y: 180.07021517553795 },
    //         { x: 169.486301369863,	y: 180.10045662100458 },
    //         { x: 169.53333333333333,	y: 179.94137931034481 },
    //         { x: 169.97538100820634,	y: 179.7409144196952 },
    //         { x: 170.12455934195066,	y: 179.6909518213866 },
    //         { x: 170.47641509433964,	y: 179.4811320754717 },
    //         { x: 170.7512019230769,	y: 179.37980769230768 },
    //         { x: 170.9652278177458,	y: 179.34772182254196 },
    //         { x: 170.85103785103786,	y: 179.16239316239316 },
    //         { x: 171.16786570743403,	y: 179.04796163069545 },
    //         { x: 171.52033492822966,	y: 178.91148325358853 },
    //         { x: 171.1949152542373,	y: 178.96004842615014 },
    //         { x: 171.48347613219096,	y: 178.84332925336597 },
    //         { x: 171.9101941747573,	y: 178.64805825242718 },
    //         { x: 171.98422330097088,	y: 178.5509708737864 },
    //         { x: 172.2832512315271,	y: 178.44334975369458 },
    //         { x: 172.46401985111663,	y: 178.12034739454094 },
    //         { x: 172.18695106649938,	y: 178.26474278544543 },
    //         { x: 172.4080604534005,	y: 177.97229219143577 },
    //         { x: 172.51207115628972,	y: 177.87801778907243 },
    //         { x: 172.72952853598014,	y: 177.6712158808933 },
    //         { x: 172.87939698492463,	y: 177.65201005025125 },
    //         { x: 173.0557620817844,	y: 177.45724907063197 },
    //         { x: 173.03643216080403,	y: 177.35175879396985 },
    //         { x: 173.10288582183188,	y: 177.0727728983689 },
    //         { x: 172.86825595984942,	y: 176.68381430363866 },
    //         { x: 173.21761658031087,	y: 176.4520725388601 },
    //         { x: 173.24191461837,	y: 176.24062095730918 },
    //         { x: 173.43495400788436,	y: 176.23127463863338 },
    //         { x: 173.65653896961692,	y: 176.13870541611624 },
    //         { x: 173.78278145695364,	y: 176.05695364238412 },
    //         { x: 173.94141145139815,	y: 176.0266311584554 },
    //         { x: 173.81333333333333,	y: 175.91866666666667 },
    //         { x: 174.03643724696354,	y: 175.82860998650472 },
    //         { x: 174.28877005347593,	y: 175.66711229946523 },
    //         { x: 174.6417112299465,	y: 175.6818181818182 },
    //         { x: 174.55200000000002,	y: 175.632 },
    //         { x: 175.13125845737483,	y: 175.38700947225982 },
    //         { x: 175.12228260869566,	y: 175.3070652173913 },
    //         { x: 175.22636484687084,	y: 175.27962716378164 },
    //         { x: 174.1978465679677,	y: 174.6877523553163 },
    //         { x: 174.88079470198676,	y: 174.2953642384106 },
    //         { x: 175.2023653088042,	y: 174.4388961892247 },
    //         { x: 175.4484126984127,	y: 174.1574074074074 },
    //         { x: 175.43866666666668,	y: 174.22666666666666 },
    //         { x: 175.44090305444888,	y: 174.04515272244356 },
    //         { x: 176.1770145310436,	y: 174.02377807133422 },
    //         { x: 176.18741808650066,	y: 173.91612057667103 },
    //         { x: 176.8439531859558,	y: 173.8439531859558 },
    //         { x: 176.88243064729193,	y: 173.80317040951124 },
    //         { x: 177.58970976253298,	y: 173.7598944591029 },
    //         { x: 177.7715404699739,	y: 173.83159268929504 },
    //         { x: 178.30789473684212,	y: 173.6184210526316 },
    //         { x: 179.246719160105,	y: 173.2795275590551 },
    //         { x: 179.59767141009056,	y: 173.38551099611902 },
    //         { x: 179.8855656697009,	y: 173.481144343303 },
    //         { x: 180.31647211413747,	y: 173.32555123216602 },
    //         { x: 180.9463601532567,	y: 173.16602809706256 },
    //         { x: 181.41153846153844,	y: 172.94358974358974 },
    //         { x: 181.45854922279793,	y: 173.0336787564767 },
    //         { x: 182.0089974293059,	y: 172.90102827763496 },
    //         { x: 182.21548387096774,	y: 172.81677419354838 },
    //         { x: 182.86917098445596,	y: 172.8277202072539 },
    //         { x: 183.3753246753247,	y: 172.8181818181818 },
    //         { x: 183.7538860103627,	y: 172.70466321243524 },
    //         { x: 184.40843214756256,	y: 172.65217391304347 },
    //         { x: 184.625,	y: 172.671875 },
    //         { x: 184.9655629139073,	y: 172.65298013245032 },
    //         { x: 185.43857331571996,	y: 172.66050198150594 },
    //         { x: 185.8064085447263,	y: 172.79038718291054 },
    //         { x: 185.98785425101215,	y: 172.6288798920378 },
    //         { x: 186.3787061994609,	y: 172.53773584905662 },
    //         { x: 186.59615384615384,	y: 172.68269230769232 },
    //         { x: 187.43939393939394,	y: 172.60743801652893 },
    //         { x: 187.62295081967213,	y: 172.5587431693989 },
    //         { x: 187.82016348773843,	y: 172.71525885558583 },
    //         { x: 188.02912621359224,	y: 172.74479889042996 },
    //         { x: 188.49653259361997,	y: 172.70457697642163 },
    //         { x: 188.86694677871148,	y: 172.80112044817926 },
    //         { x: 189.73521126760562,	y: 172.80985915492957 },
    //         { x: 189.72815533980582,	y: 172.7628294036061 },
    //         { x: 190.180790960452,	y: 172.95762711864407 },
    //         { x: 190.51339915373765,	y: 172.81382228490833 },
    //         { x: 190.74643874643874,	y: 172.8988603988604 },
    //         { x: 190.94915254237287,	y: 172.89265536723164 },
    //         { x: 191.20786516853934,	y: 172.9817415730337 },
    //         { x: 191.61285714285714,	y: 173.01714285714286 },
    //         { x: 191.91473988439304,	y: 172.92485549132948 },
    //         { x: 191.91292134831463,	y: 172.91573033707866 },
    //         { x: 192.14914772727275,	y: 172.9034090909091 }
    //         ];
    // }
}


// WEBPACK FOOTER //
// ./src/components/test/TestView.tsx